import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({ checked, onChange, color, readOnly }) => (
    <div
        className={`custom-checkbox ${checked ? 'checked ' : ' '}${readOnly ? 'readonly' : color || ''}`}
        onClick={!readOnly ? onChange : null}
    />
);

Checkbox.propTypes = {
    checked: PropTypes.bool.isRequired,
    color: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    onChange: PropTypes.func,
};

Checkbox.defaultProps = {
    onChange: () => {},
    readOnly: false,
};

export default React.memo(Checkbox);



// WEBPACK FOOTER //
// ./source/components/customCheckbox.js